import React from "react"
import Logo from "../assets/logo/full.svg"

export interface FooterProps {
  lang: string
}

export class Footer extends React.Component<FooterProps> {
  render() {
    return (
      <div className="bg-primary flex flex-col items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 260"
          fillOpacity={0}
          className="fill-current text-white relative z-50 -top-px"
        >
          <path
            fill-opacity="1"
            d="M0,96L48,117.3C96,139,192,181,288,176C384,171,480,117,576,128C672,139,768,213,864,240C960,267,1056,245,1152,213.3C1248,181,1344,139,1392,117.3L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          ></path>
        </svg>
        <div className="py-12 px-6 flex flex-col items-center gap-4">
          <Logo height={50} width={160} />
          <p className="text-base font-light text-red-200 text-center">
            Copyright © {new Date().getFullYear()}, OneZero Company. All rights
            reserved.
          </p>
        </div>
      </div>
    )
  }
}
